import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as actions from '../actions/tax-exemptions.action';
import * as cartActions from '../actions/carts.action';
import { switchMap, map, catchError, withLatestFrom, filter } from 'rxjs/operators';
import { CustomerService } from '../../services';
import { Store } from '@ngrx/store';
import { getCustomerAccessToken } from '../selectors';

@Injectable()
export class TaxExemptionsEffects {
  constructor(private actions$: Actions, private service: CustomerService, private store: Store) {}

  checkExemptions$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(actions.CheckTaxExemptions),
      withLatestFrom(this.store.select(getCustomerAccessToken)),
      switchMap(([{}, token]) =>
        this.service.checkTaxExemptionStatus(token?.accessToken || '').pipe(
          map(result => actions.CheckTaxExemptionsSuccess({ result })),
          catchError(errors => of(actions.CheckTaxExemptionsFail({ errors })))
        )
      )
    );
  });

  checkExemptionsSuccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(actions.CheckTaxExemptionsSuccess),
      filter(({ result }) => result.valid),
      map(({}) => cartActions.StartCheckout())
    );
  });
}
